import { CartItem } from 'ng-shopping-cart';

export class OrderItem extends CartItem {

  constructor(itemData: any)
  {
    super();

    this._name = itemData.name;
    this._imageUrl = itemData.imageUrl;
    this._quantity = itemData.quantity;
    this.Quantity = itemData.quantity;
    this._price = itemData.price;
    this.description = itemData.description;
    this.size = itemData.size;
    this._id = itemData.id;
  }

  public _name: string;
  _price: number;
  _imageUrl: string;
  _quantity: number;
  public description: string;
  public size: string;
  public Quantity: number;
  _id: string;

  public setId(anId: any) {
    this._id = anId;
      
  }
  public getId(): any {
    return this._id;
      }
  public getName(): string {
    return this._name;
  }
  public getPrice(): number {
    return this._price;
  }
  public getImage(): string {
    return this._imageUrl;
  }
  public getQuantity(): number {
    return this.Quantity;
  }
  public setQuantity(quantity: number) {
    this.Quantity = quantity;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/order-item.ts